import { render, staticRenderFns } from "./DashGridColumnChartForm.vue?vue&type=template&id=a94ebc44&scoped=true&"
import script from "./DashGridColumnChartForm.vue?vue&type=script&lang=ts&"
export * from "./DashGridColumnChartForm.vue?vue&type=script&lang=ts&"
import style0 from "./DashGridColumnChartForm.vue?vue&type=style&index=0&id=a94ebc44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@6.7.1_lodash@4.17.21_vue-template-compiler@2.7.14_webpack@5.73.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94ebc44",
  null
  
)

export default component.exports